<template>
  <o-section
    :title="label || schema.verbose_name"
    not-closable
    :level="level + 1"
    body-classes="p-0"
  >
    <b-alert show variant="warning" v-if="checkRowDetails">{{
      checkRowDetails
    }}</b-alert>

    <o-item-editable-table
      v-model="items"
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'invoice_type')">
          {{ schema.fields.invoice_type.label }}
        </th>
        <th v-if="canSee(schema, 'date_invoiced')">
          {{ schema.fields.date_invoiced.label }}
        </th>
        <th v-if="canSee(schema, 'invoice_number')">
          {{ schema.fields.invoice_number.label }}
        </th>
        <th v-if="canSee(schema, 'paid')">{{ schema.fields.paid.label }}</th>
      </template>
      <template slot="o-body" slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'invoice_type')">
          <o-widget-wrapper
            :schema="schema"
            name="invoice_type"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-select
              v-model="items[index].invoice_type"
              :items="optionCodeInvoiceTypeItems"
              text-field="description"
              value-field="id"
              sort-field="description"
              :form-state="formState"
              :loading="optionCodeInvoiceTypeWorking"
              name="invoice_type"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.invoice_type"
              allow-add
              store-name="CodeInvoiceType"
              add-title="Create New"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <code-invoice-type-form
                  :item="item"
                  :form-state="formState"
                  :server-errors="serverErrors"
                  in-modal
                ></code-invoice-type-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'date_invoiced')">
          <o-widget-wrapper
            :schema="schema"
            name="date_invoiced"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-date-time
              v-model="items[index].date_invoiced"
              name="date_invoiced"
              v-bind="schema.fields.date_invoiced"
              :form-state="formState"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
            ></o-date-time>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'invoice_number')">
          <o-widget-wrapper
            :schema="schema"
            name="invoice_number"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-text-field
              v-model="items[index].invoice_number"
              :form-state="formState"
              name="invoice_number"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.invoice_number"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'paid')">
          <o-widget-wrapper
            :schema="schema"
            name="paid"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-checkbox
              v-model="items[index].paid"
              :form-state="formState"
              name="paid"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.paid"
            ></o-checkbox>
          </o-widget-wrapper>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../vue-ocom/components/layout/OSection";

export default {
  name: "InvoiceFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("Invoice"),
    CreateCodeTableFetchMixin(["CodeInvoiceType", "User"]),
  ],
  components: { OItemEditableTable, OSection },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.Invoice,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.Invoice),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {
    checkRowDetails() {
      const vm = this;
      var result = "";
      _.forEach(vm.items, function (item) {
        if (
          item.invoice_number == "" ||
          item.invoice_number == null ||
          item.date_invoiced == null
        ) {
          result = "Please fill in all the details";
          return result;
        }
      });
      return result;
    },
  },
  created() {
    // this.loadCodeTables()
  },
};
</script>
